<div class="top-bar">
  <h1 class="top-bar__title">{{ 'UI.ALERTS' | translate }}</h1>
</div>

<div class="page">
  @for (alert of alerts; track alert) {
    <app-alert [alert]="alert"></app-alert>
  } @empty {
    <div class="card">
      <div class="empty-state">
        <ng-icon name="heroBell" size="32"/>
        <div class="empty-state__title">{{ 'UI.NO_ALERT' | translate }}</div>
      </div>
    </div>
  }
</div>
